import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importInvoiceSvbApi = createApi({
  reducerPath: "importInvoiceSvbApi",
  baseQuery,
  tagTypes: ["svbDetails"],

  endpoints: (builder) => ({
    getSvbDetailsById: builder.query({
      query: ({ id,subId }) => {
        return {
          url: `import/invoice/svbDetails/${id}/${subId}`,
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return response?.data ?? null;
      },
      providesTags: ["svbDetails"],
    }),

    updateSvbDetails: builder.mutation({
      query: ({ id, dataId, ...data }) => {
        return {
          url: `import/invoice/svbDetails/${id}/${dataId}`,
          method: "PUT",
          body: { SvbDetails: data },
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        };
      },
      invalidatesTags: ["svbDetails"],
    }),
    
  }),
});

export const {
  useGetSvbDetailsByIdQuery,
  useLazyGetSvbDetailsByIdQuery,
  useUpdateSvbDetailsMutation,
} = importInvoiceSvbApi;
